import axios from 'axios';

const BASE = process.env.REACT_APP_API_BASE_URL || '';  

export const uploadFiles = (formData) =>
  axios.post(`${BASE}/api/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });